import { useState, useEffect, useCallback } from "react";
import POPUP from "components/popup";
import api from "services/api";
import { getcodCidade } from "functions/gettabconfig";
import config from "config";
import IMAGEM from "components/imagem";
import { formatDate, formatNumber, maskName } from "components/formatos";
import Avaliacao from "components/avaliacao";
import MostraEstrelas from "components/mostraestrelaas";
import './style.css';
import CarrosselPromocoes from "components/CarroselPromocoes";

function DIALOGLOJADETALHE(props) {
    function Close() {
        props.setTrigger(false);
    }
    const [promocoes, setPromocoes] = useState([]);
    const [ppavalisar, setPpavalisar] = useState(false);
    const [avaliacoes, setAvaliacoes] = useState([]);
    const [pplistaavaliacoes, setPplistaavaliacoes] = useState(false);

    // Função para buscar promoções
    const getAvaliacoes = useCallback(async () => {
        try {
            api.get(`/v1/avaliacoes/${props.dados.id_estabelecimento}`)
                .then(response => {
                    setAvaliacoes(response.data);
                });
        } catch (error) {
            console.error("Erro ao carregar avaliacoes:", error);
        }
    }, [props.dados.id_estabelecimento]);

    const getPromocoes = useCallback(async () => {
        try {
            api.get(`${config.PROMOCOES}/${props.dados.id_estabelecimento}?cod_cidade=${getcodCidade()}`)
                .then(response => {
                    setPromocoes(response.data);
                });
        } catch (error) {
            console.error("Erro ao carregar promoções:", error);
        }
    }, [props.dados.id_estabelecimento]);

    // Função para abrir URL
    const abrirUrl = (link) => {
        if (link) {
            window.open(link, "_blank");
        } else {
            console.error("URL inválida");
        }
    };

    useEffect(() => {
        if (props.trigger) {
            getPromocoes();
            getAvaliacoes();
        }
    }, [props.trigger]);

    useEffect(() => {
        if (props.trigger) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [props.trigger]);

    return <POPUP
        trigger={props.trigger}
        setTrigger={Close}>

        <div className="loja-detalhe">

            <div className="loja-detalhe-header">
                {props.dados?.url_foto && props.dados.url_foto !== '' && !props.dados.url_foto.endsWith('/') && <IMAGEM
                    participantes={true}
                    src={`${config.BASEIMG}/${props.dados.url_foto}`}
                    width="30%"
                    className="loja-imagem"
                />}
                {!ppavalisar && !pplistaavaliacoes? <>
                    <div className="loja-avaliacao-container">
                        <button type="button"
                            className="btn btn-warning"
                            onClick={() => setPpavalisar(true)}>
                            AVALIAR</button>
                        <p>Avaliação: {formatNumber(props.dados.avaliacao, 1)}</p>
                        <div className="loja-estrelas" onClick={(e) => setPplistaavaliacoes(true)}>
                            {Array.from({ length: 5 }, (_, index) => (
                                <i
                                    key={index}
                                    className={`fa-star ${index < props.dados.avaliacao ? 'fas' : 'far'}`}
                                ></i>
                            ))}
                        </div>
                    </div>
                    {avaliacoes.resumo &&
                        <MostraEstrelas
                            total={avaliacoes.resumo.nro_avaliacoes ?? 0}
                            cinco={avaliacoes.resumo.estrelas5 ?? 0}
                            quatro={avaliacoes.resumo.estrelas4 ?? 0}
                            tres={avaliacoes.resumo.estrelas3 ?? 0}
                            dois={avaliacoes.resumo.estrelas2 ?? 0}
                            um={avaliacoes.resumo.estrelas1 ?? 0}
                        />
                    }
                </>
                    : null
                }
            </div>
            {!ppavalisar && <>
                <div className="loja-content">
                    <p>{props.dados.endereco}</p>
                    <p>Telefone: {props.dados.telefone}</p>
                    <div className="loja-avaliacao-container">
                        <div className="whatsapp-button loja-whatsapp-button">
                            <a
                                href={`https://wa.me/${props.dados.whatsup}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="loja-whatsapp-button"
                            >
                                <i className="fab fa-whatsapp"></i>
                                Enviar WhatsApp
                            </a>
                        </div>
                        {props.dados.site && <button
                            onClick={() => abrirUrl(props.dados.site)}
                            className="loja-button">
                            Acesse aqui
                        </button>
                        }
                    </div>
                    {!ppavalisar && !pplistaavaliacoes && promocoes.length > 0 &&  <>
                           <CarrosselPromocoes lpromocoes={promocoes} />    
                        </>
                    }
                </div>
            </>
            }
            {ppavalisar && <>
                <Avaliacao
                    dados={props.dados}
                    setTrigger={setPpavalisar}
                />
            </>
            }
            {pplistaavaliacoes && <>
                <div className="loja-avaliacao-listas">
                    <h2>Avaliações</h2>
                    <button type="button" 
                       onClick={() => setPplistaavaliacoes(false)}
                     className="btn btn-warning">Voltar</button>
                    <div className="row">
                                <div className="col-2">Usuário</div>
                                <div className="col-1">Data</div>
                                <div className="col-4">Comentário</div>
                                <div className="col-4">Resposta</div>
                                <div className="col-1">Estrelas</div>
                            </div>
                    {avaliacoes.itens.map((a, index) => {
                        return <div key={index}>
                            <div className="row">
                                <div className="col-2">{maskName(a.nomeusuario)}</div>
                                <div className="col-1">{formatDate(a.datahora)}</div>
                                <div className="col-4">{a.den_avaliacao}</div>
                                <div className="col-4">{a.den_resposta}</div>
                                <div className="col-1">{a.nro_estrelas}</div>
                            </div>
                        </div>
                    })}
                </div>
            </>
            }
        </div>
    </POPUP>
}

export default DIALOGLOJADETALHE;